"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRegExp = void 0;
exports.isRegExp = (value) => value instanceof RegExp;
//# sourceMappingURL=is-reg-exp.js.map